export const ADD_CUSTOMER_HEAD_LOADING = "ADD_CUSTOMER_HEAD_LOADING";
export const ADD_CUSTOMER_HEAD_SUCCESS = "ADD_CUSTOMER_HEAD_SUCCESS";
export const ADD_CUSTOMER_HEAD_ERROR = "ADD_CUSTOMER_HEAD_ERROR";
export const CLEAR_CUSTOMER_HEAD_DATA = "CLEAR_CUSTOMER_HEAD_DATA";
